<span *ngIf="!noContainer" class="icon c-btn__iconImage {{ containerClass }}">
  <i class="iconFont {{ iconClass }}"></i>
</span>

<i *ngIf="noContainer" class="iconFont {{ iconClass }}"></i>
